import { render, staticRenderFns } from "./OrderBox.vue?vue&type=template&id=4108ca46&"
import script from "./OrderBox.vue?vue&type=script&lang=js&"
export * from "./OrderBox.vue?vue&type=script&lang=js&"
import style0 from "./OrderBox.vue?vue&type=style&index=0&id=4108ca46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports